import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  ArrowDownUp,
  ArrowRight,
  ArrowUpDown,
  SquareCheck,
  SquareX,
} from "lucide-react";
import moment from "moment";
import { ShowError, ShowSuccess } from "../../../utils/ToasFunction";
import ImageTag from "../../reusebale/imageTag";
import MyLoader from "../../reusebale/MyLoader";
import NoData from "../../reusebale/noData";
import ParagraphTag from "../../reusebale/Paragraph";

import BaseUrl from "../../../constants/BaseUrl";
import db from "../../../db/index.json";

const LandlordTable = ({ onViewDetails, handleLandlordTable }) => {
  const { rightPanel } = db;

  const [page, setPage] = useState(1);
  const [AllLandlord, setAllLandlord] = useState([]);
  const [Loading, setLoading] = useState(false);

  const [toggleLoader, setToggleLoader] = useState(false);

  const { loginSuccess } = useSelector((state) => state.auth);

  const GetAllLandlord = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}landlord/profile/getAllLandlordProfiles?page=${page}&limit=10`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setLoading(false);
          setAllLandlord(result.data);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetAllLandlord();
  }, []);

  const [sortConfig, setSortConfig] = useState({
    key: "lease",
    direction: "asc",
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...AllLandlord].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setAllLandlord(sortedData);
  };

  const ToggleLandlordLogin = (recordId, landloardId) => {
    setToggleLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const raw = JSON.stringify({
      recordId: recordId,
      landloardId: landloardId,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}landlord/profile/landlordToggleAllowLogin`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          ShowSuccess(result.message);
          GetAllLandlord();
          setToggleLoader(false);
        } else {
          ShowError(result.message);
          setToggleLoader(false);
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <div className="bg-white rounded-2xl py-5 px-4 w-full mt-5 shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
      <div className="flex justify-between items-center ">
        <ParagraphTag
          content={"Accepted Landlords"}
          classes="text-darkColor font-popinsSemiBold text-base"
        />

        <ParagraphTag
          content={rightPanel.viewall}
          classes="text-themeColor font-popinsSemiBold text-xs cursor-pointer"
          onTrigger={handleLandlordTable}
        />
      </div>
      <div className="overflow-x-scroll w-full h-[300px] panelScroll pt-2">
        <table className="w-full ">
          <thead className="sticky top-0 bg-white">
            <tr className="border-b border-black/20">
              <th className="w-[23%] text-left pb-2">
                <span className="flex">
                  <ParagraphTag
                    content={rightPanel.landlords}
                    classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                  />
                  {sortConfig.key === "lease" ? (
                    sortConfig.direction === "asc" ? (
                      <ArrowUpDown
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("lease")}
                      />
                    ) : (
                      <ArrowDownUp
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("lease")}
                      />
                    )
                  ) : (
                    <ArrowUpDown
                      className="cursor-pointer"
                      size={13}
                      color="#6F6F6F"
                      onClick={() => requestSort("lease")}
                    />
                  )}
                </span>
              </th>
              <th className="w-[23%] pb-2">
                <span className="flex">
                  <ParagraphTag
                    content={rightPanel.company}
                    classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                  />
                  {sortConfig.key === "status" ? (
                    sortConfig.direction === "asc" ? (
                      <ArrowUpDown
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("status")}
                      />
                    ) : (
                      <ArrowDownUp
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("status")}
                      />
                    )
                  ) : (
                    <ArrowUpDown
                      className="cursor-pointer"
                      size={13}
                      color="#6F6F6F"
                      onClick={() => requestSort("status")}
                    />
                  )}
                </span>
              </th>
              <th className="w-[8%] pb-2">
                <span className="flex justify-center">
                  <ParagraphTag
                    content={rightPanel.status}
                    classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                  />
                  {sortConfig.key === "leasedProperty" ? (
                    sortConfig.direction === "asc" ? (
                      <ArrowUpDown
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("leasedProperty")}
                      />
                    ) : (
                      <ArrowDownUp
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("leasedProperty")}
                      />
                    )
                  ) : (
                    <ArrowUpDown
                      className="cursor-pointer"
                      size={13}
                      color="#6F6F6F"
                      onClick={() => requestSort("leasedProperty")}
                    />
                  )}
                </span>
              </th>
              <th className="w-[13%] pb-2">
                <span className="flex justify-center">
                  <ParagraphTag
                    content={rightPanel.createDate}
                    classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                  />
                  {sortConfig.key === "Rent" ? (
                    sortConfig.direction === "asc" ? (
                      <ArrowUpDown
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("Rent")}
                      />
                    ) : (
                      <ArrowDownUp
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("Rent")}
                      />
                    )
                  ) : (
                    <ArrowUpDown
                      className="cursor-pointer"
                      size={13}
                      color="#6F6F6F"
                      onClick={() => requestSort("Rent")}
                    />
                  )}
                </span>
              </th>
              <th className="w-[13%] pb-2">
                <span className="flex justify-center">
                  <ParagraphTag
                    content={rightPanel.phone}
                    classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                  />
                  {sortConfig.key === "phoneNumber" ? (
                    sortConfig.direction === "asc" ? (
                      <ArrowUpDown
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("phoneNumber")}
                      />
                    ) : (
                      <ArrowDownUp
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("phoneNumber")}
                      />
                    )
                  ) : (
                    <ArrowUpDown
                      className="cursor-pointer"
                      size={13}
                      color="#6F6F6F"
                      onClick={() => requestSort("phoneNumber")}
                    />
                  )}
                </span>
              </th>
              <th className="w-[10%] pb-2">
                <span className="flex justify-center">
                  <ParagraphTag
                    content={rightPanel.change}
                    classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                  />
                  {sortConfig.key === "changeStatus" ? (
                    sortConfig.direction === "asc" ? (
                      <ArrowUpDown
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("changeStatus")}
                      />
                    ) : (
                      <ArrowDownUp
                        className="cursor-pointer"
                        size={13}
                        color="#6F6F6F"
                        onClick={() => requestSort("changeStatus")}
                      />
                    )
                  ) : (
                    <ArrowUpDown
                      className="cursor-pointer"
                      size={13}
                      color="#6F6F6F"
                      onClick={() => requestSort("changeStatus")}
                    />
                  )}
                </span>
              </th>
              <th className="w-[12%] text-right pr-4 pb-2">
                <ParagraphTag
                  content={rightPanel.quick}
                  classes="text-darkColor/40 font-popinsSemiBold text-xs"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {AllLandlord.filter((val) => val.approvedStatus === "accepted").map(
              (item, i) => (
                <tr
                  key={i}
                  className="hover:bg-gray-100 rounded-md cursor-pointer"
                >
                  <td className="py-2">
                    <div className="flex items-center justify-between">
                      <div className="w-[25%] rounded-full">
                        <ImageTag
                          path={
                            item?.personalInformation?.profileImage?.url ||
                            "/assets/daashboard/landlord-color.png"
                          }
                          classes="w-[45px] h-[45px] rounded-full"
                          altText="logo"
                        />
                      </div>
                      <div className="w-[75%] cursor-pointer">
                        <ParagraphTag
                          content={`LID-${item?._id?.slice(0, 10)}`}
                          classes="text-darkColor/50 font-popinsMedium text-xs"
                        />
                        <ParagraphTag
                          content={`${item?.personalInformation?.firstName} ${item?.personalInformation?.lastName}`}
                          classes="text-darkColor font-popinsSemiBold text-sm"
                        />
                      </div>
                    </div>
                  </td>
                  <td className="py-2">
                    <div className="flex items-center justify-between">
                      <div className="w-[25%] rounded-full">
                        <ImageTag
                          path={
                            item?.companyInformation?.companyLogo?.url ||
                            "/assets/daashboard/company-info-Round.png"
                          }
                          classes="w-[50px] w-[50px] rounded-full"
                          altText="logo"
                        />
                      </div>
                      <div className="w-[75%] cursor-pointer">
                        <ParagraphTag
                          content="Company"
                          classes="text-darkColor/50 font-popinsMedium text-xs"
                        />
                        <ParagraphTag
                          content={item?.companyInformation?.companyName}
                          classes="text-darkColor font-popinsSemiBold text-sm"
                        />
                      </div>
                    </div>
                  </td>

                  <td className="py-2 font-popinsMedium text-darkColor text-sm">
                    <div className="flex justify-center items-center">
                      <span>
                        {(() => {
                          switch (item.approvedStatus) {
                            case "accepted":
                              return <SquareCheck color="#01CB78" size={20} />;
                            default:
                              return <SquareX color="#E43B3B" size={20} />;
                          }
                        })()}
                      </span>
                    </div>
                  </td>
                  <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                    {moment(item?.createdAt).format("MM/DD/YYYY")}
                  </td>
                  <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                    {item?.personalInformation?.phoneNumber}
                  </td>
                  <td className="py-2 px-4 font-popinsMedium text-darkColor text-xs text-center">
                    {toggleLoader ? (
                      <div className="flex justify-center">
                        <MyLoader />
                      </div>
                    ) : (
                      <div className="flex justify-center">
                        <label class="inline-flex items-center cursor-pointer relative pl-3">
                          <input
                            checked={item.allowLogin ? true : false}
                            value={true}
                            type="checkbox"
                            class="sr-only peer"
                            onChange={() => {
                              ToggleLandlordLogin(item._id, item.landloardId);
                            }}
                          />
                          <div class="relative w-11 h-6 bg-[#E43B3B38] peer-focus:outline-none rounded-full peer dark:bg-[#E43B3B38] peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-[#0381CA] after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-[#0381CA] after:border-[#0381CA] after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-[#0381CA] peer-checked:bg-[#E43B3B38]"></div>
                        </label>
                      </div>
                    )}
                  </td>
                  <td className="pt-5 2xl:pt-4 px-4 flex justify-center items-center h-full">
                    <div
                      onClick={() => {
                        onViewDetails(item);
                      }}
                      className="flex justify-center items-center border border-themeColor w-7 h-7 rounded-md cursor-pointer"
                    >
                      <ArrowRight color="#6F6F6F" size={18} strokeWidth={2} />
                    </div>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
        {AllLandlord.length === 0 && (
          <div className="w-full mt-5">
            <NoData />
          </div>
        )}
      </div>
    </div>
  );
};

export default LandlordTable;
